export const addressesConstants = {
	INACTIVATE: 'INACTIVATE',
	ADD_OR_UPDATE: 'ADD_OR_UPDATE',
	GET: 'GET',
	SET_EDITING_ADDRESS_ID: 'SET_EDITING_ADDRESS_ID',
	OPEN_EDIT_ADDRESS_MODAL: 'OPEN_EDIT_ADDRESS_MODAL',
	OPEN_NEW_ADDRESS_MODAL: 'OPEN_NEW_ADDRESS_MODAL',
	CLOSE_EDIT_ADDRESS_MODAL: 'CLOSE_EDIT_ADDRESS_MODAL',
	CLOSE_NEW_ADDRESS_MODAL: 'CLOSE_NEW_ADDRESS_MODAL',
	SET_ADDRESSES_OWNER_ID: 'SET_CLIENT_ID'
}
